import React, { Fragment } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { noop } from 'lodash-es';
import { ConsumerReviewsEntities } from 'client/data/models/consumer-reviews';
import { buildConsumerReviewsUrl } from 'site-modules/shared/utils/consumer-reviews/url-builder';
import { venomHistory } from 'client/utils/history/venom-history';

export function RatingDistribution({
  percentageRated,
  rating,
  reviewsFilter = null,
  vehicleFilter = null,
  clickable,
  addLoading = noop,
}) {
  function onClick() {
    addLoading();

    setTimeout(() => {
      venomHistory.push(buildConsumerReviewsUrl({ ...reviewsFilter, rating }, vehicleFilter));
    }, 0);
  }

  const innerContent = (
    <Fragment>
      {rating} <span className="visually-hidden">star</span>
      <span
        className={classnames('rating-star icon-star-full mx-0_5', { 'text-primary-darker': !clickable })}
        aria-hidden
      />
      <span className="summary-progress bg-gray-lighter d-flex align-items-stretch rounded col p-0">
        <span
          className={classnames('rounded', { 'progress-fill': clickable, 'bg-primary-darker': !clickable })}
          style={{ width: `${percentageRated}%` }}
        />
      </span>
      <span className="summary-percent text-end">({percentageRated}%)</span>
    </Fragment>
  );

  return clickable ? (
    <button
      onClick={onClick}
      className="summary-rating p-0 size-14 d-flex align-items-center text-primary-darker bg-transparent w-100"
    >
      {innerContent}
    </button>
  ) : (
    <div className="summary-rating size-14 d-flex align-items-center text-gray-darker">{innerContent}</div>
  );
}

RatingDistribution.propTypes = {
  percentageRated: PropTypes.number.isRequired,
  rating: PropTypes.number.isRequired,
  clickable: PropTypes.bool.isRequired,
  addLoading: PropTypes.func,
  reviewsFilter: ConsumerReviewsEntities.ReviewsFilter,
  vehicleFilter: ConsumerReviewsEntities.VehicleFilter,
};
